module.exports = __webpack_public_path__ + "static/img/moaUninstall_pic01.70c3cdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaUninstall/moaUninstall_pic01.png
// module id = 546
// module chunks = 1